export default "__VITE_ASSET__LkOcDZVV__"